import { Avatar, styled } from "@mui/material";
import { IStyledAvatarProps } from "./types";

const StyledAvatar = styled(Avatar)<IStyledAvatarProps>(({theme})=>({
    border: `1px solid ${theme.palette.secondary.main}`,
    width: theme.spacing(3),
    height: theme.spacing(3),
    fontSize: `${(theme as any).typography.sizes.xs} !important`,
    color: `${(theme as any).palette.neutral.lighter} !important`,
    backgroundColor: `${(theme as any).palette.neutral.darker} !important`
}))

export {StyledAvatar}